import React from 'react'
import { ReviewFilterBadges } from '../DashboardReview/ReviewFilter'
import { Subtask } from 'constants/interfaces'
import { CollapsibleContent } from 'components/TasksV2/UI/CollapsibleContent'
import { ExecutionStatus } from '../ExecutionStatus'
import { useExecutionText } from '../../hooks/useExecutionText'
import keys from 'constants/keys'

export const ExecutionDescription: React.FC<{
  subtask: Pick<Subtask, 'title' | 'type'> & Partial<Pick<Subtask, 'content' | 'is_required'>>
  notices?: React.ReactNode
  status?: number
}> = ({ subtask, status, notices }) => {
  const t = useExecutionText()
  const content = subtask.content
  return (
    <section className="execution-description">
      {notices}
      <div className="execution-description-heading">
        <ExecutionStatus status={status} />
        <span className="execution-muted">
          {`${subtask.type === keys.SUBTASK_TYPES.IMAGE_SUBTASK ? t.photo : t.video} · ${
            subtask.is_required ? t.required : t.optional
          }`}
        </span>
        <div style={{ marginInlineStart: 'auto' }}>
          <ReviewFilterBadges />
        </div>
      </div>
      <div className="execution-description-scroll">
        <CollapsibleContent
          text={content?.text}
          rich_text={content?.rich_text}
          images={content?.images}
          videos={content?.videos}
          files={content?.files}
          showHeader={false}
        />
      </div>
    </section>
  )
}
